module.exports = __webpack_public_path__ + "static/media/Niveau_elN3_1_1046912.5c142bbd.png";